// src/components/shared/SiteFooter.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../../lib/AppContext';
import { t } from '../../lib/i18n';
import NewsletterSignup from './NewsletterSignup';

export default function SiteFooter() {
  const { lang } = useApp();

  return (
    <footer className="sitefooter">
      <div className="sitefooter-inner">
        <div className="sitefooter-brand">
          <div style={{
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: '1.6rem', letterSpacing: '.08em', color: '#4cca74',
          }}>
            CosmiqHerbz
          </div>
          <p>
            Premium botanical collectibles for the discerning European collector.
            All products sold as collector's items. 18+ only. EU-compliant.
          </p>
          <div style={{ display: 'flex', gap: 8 }}>
            {['ig', 'tt', 'fb', 'tg'].map(s => (
              <a key={s} href="#" style={{
                width: 32, height: 32,
                background: '#1a1a1a',
                border: '1px solid rgba(255,255,255,.07)',
                borderRadius: 8,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#555', fontSize: '.75rem', fontWeight: 700,
                textDecoration: 'none', fontFamily: "'Barlow Condensed', sans-serif",
                letterSpacing: '.04em', textTransform: 'uppercase',
                transition: 'color .2s, border-color .2s',
              }}
              onMouseOver={e => { e.currentTarget.style.color = '#4cca74'; e.currentTarget.style.borderColor = 'rgba(76,202,116,.3)'; }}
              onMouseOut={e  => { e.currentTarget.style.color = '#555';    e.currentTarget.style.borderColor = 'rgba(255,255,255,.07)'; }}
              >
                {s}
              </a>
            ))}
          </div>

          {/* Footer newsletter widget */}
          <NewsletterSignup variant="footer" source="footer" />
        </div>

        <div className="footer-col">
          <h5>Shop</h5>
          <ul>
            <li><Link to="/#new-arrivals">New Arrivals</Link></li>
            <li><Link to="/#cbd-flower">CBD Flowers</Link></li>
            <li><Link to="/#hemp-resin">Hemp Resin</Link></li>
            <li><Link to="/#vapes-carts">Vapes & Carts</Link></li>
            <li><Link to="/#bundles">Bundles</Link></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Info</h5>
          <ul>
            <li><Link to="/blog">{t('blog', lang)}</Link></li>
            <li><Link to="/loyalty">{t('loyalty', lang)}</Link></li>
            <li><Link to="/account">{t('account', lang)}</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><a href="mailto:info@cosmiqherbz.com">Email Us</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Legal</h5>
          <ul>
            <li><Link to="/legal/terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/privacy">Privacy Policy</Link></li>
            <li><Link to="/legal/cookies">Cookie Policy</Link></li>
            <li><Link to="/legal/shipping">Shipping Policy</Link></li>
            <li><Link to="/legal/disclaimer">Collector's Disclaimer</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 CosmiqHerbz. All products are collector's items — not for consumption. 18+ only.</p>
        <div className="footer-legal-links">
          <Link to="/legal/terms">T&amp;Cs</Link>
          <Link to="/legal/privacy">Privacy</Link>
          <Link to="/legal/cookies">Cookies</Link>
          <Link to="/legal/shipping">Shipping</Link>
          <Link to="/legal/disclaimer">Disclaimer</Link>
          <Link to="/contact">Contact</Link>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {['VISA', 'MC', 'PayPal', '₿ BTC', 'IBAN'].map(p => (
            <span key={p} style={{
              background: '#181818',
              border: '1px solid rgba(255,255,255,.07)',
              padding: '3px 8px', borderRadius: 4,
              fontSize: '.65rem', color: '#555',
              fontFamily: "'Barlow Condensed', sans-serif",
              letterSpacing: '.04em',
            }}>
              {p}
            </span>
          ))}
        </div>
      </div>
    </footer>
  );
}